import { Inject, Injectable } from '@angular/core';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { AppStoreConfig, DataUserDataService, DisplayDataFactoryService, WweRcResolverService } from '@ddt-web/data-service';
import { PortfolioRetrievalParams } from '@ddt-web/domain';
import { StoreService } from '@ddt-web/store-service';
import * as castArray from 'lodash/castArray';
import * as cloneDeep from 'lodash/cloneDeep';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';

import { InternalPortfolioResolverWorker } from './internal-portfolio-resolver-worker';

@Injectable()
export class AcplInternalPortfolioResolverWorker extends InternalPortfolioResolverWorker {

	constructor(
		protected displayDataService: DisplayDataFactoryService,
		protected dataUserDataService: DataUserDataService,
		protected storeService: StoreService,
		protected wweRcResolver: WweRcResolverService,
		@Inject(APP_STORE_CONFIG_TOKEN) protected storeConfig: AppStoreConfig
	) {
		super(displayDataService, dataUserDataService, storeService, wweRcResolver, storeConfig);
	}

	public handle(queryParams: any, overrideOptions: PortfolioRetrievalParams = {}): void {
		const ids = cloneDeep(castArray(get(queryParams, 'portfolios', [])));
		if (!isEmpty(ids)) {
			const portfolioBenchmarkIds = [];
			let portfolioIdAdded: boolean = false;
			ids.forEach(id => {
				const portfolioBenchmarkId = queryParams.additionalAnalysisParams?.benchmark?.[id]?.portfolioBenchmarkId;
				if (portfolioBenchmarkId && !ids.includes(portfolioBenchmarkId)) {
					portfolioBenchmarkIds.push(portfolioBenchmarkId);
					ids.push(portfolioBenchmarkId);
					portfolioIdAdded = true;
				}
			});
			this.setupInternalPortfolios(ids, portfolioBenchmarkIds, portfolioIdAdded, overrideOptions);
		}
	}
}
